import { STATUS } from '../../constants/commonConstants';

export const shoppingPreferencesInitialStore = {
  shoppingPreferencesData: {},
  shoppingPreferenceDataStatus: STATUS.IDLE
};
